QuestionsList = require 'components/scope/outcomes/questions_list'
QuestionGroupTitle = require 'components/scope/outcomes/question_group_title'
OutcomesApprovalTable = require 'components/scope/outcomes/outcomes_approval_table'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'

QuestionGroupForApproval = createReactClass
  displayName: 'QuestionGroupForApproval'
  mixins: [CustomRenderMixin]
  propTypes:
    data: PropTypes.object.isRequired
    gIndex: PropTypes.number.isRequired

  render: ->
    name = @props.data.get 'name'
    questions = @props.data.get 'questions'
    outcomes = @props.data.get 'outcomes'

    <div className='question-group'>
      <QuestionGroupTitle text={name} />
      <QuestionsList questions={questions} groupName={name} />
      <OutcomesApprovalTable
        outcomes={outcomes}
        membersMap={@props.membersMap}
        gIndex={@props.gIndex}
        readOnly={@props.readOnly}
        changeOutcomeImportance={@props.onChangeOutcomeImportance}
        showingComments={@props.showingComments}
        onCommentToggle={@props.onCommentToggle}
        todos={@props.todos}
      />
    </div>

module.exports = QuestionGroupForApproval
